// extracted by mini-css-extract-plugin
export default {"slide":"InfoCarousel_slide__T4Gvk"};